import { useEffect, useState } from "react";
import apiService from "../../service/apiService";
import pageData from "../../pages.json";
import { Form, Card, CardHeader, Row, Col } from "react-bootstrap";
import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";

const AddUserRole = () => {
  const [userRoleId, setUserRoleId] = useState(null);
  const [selectedPages, setSelectedPages] = useState([]);
  const navigate = useNavigate();
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");

  const getFlatPages = (pages) => {
    const mainPages = [];
    const innerPages = [];
  
    Object.entries(pages).forEach(([key, value]) => {
      mainPages.push({
        formId: key,
        formName: value.name,
        subForms: value.innerPages ? Object.keys(value.innerPages) : [],
        displayOrder: value.displayOrder,
      });
  
      if (value.innerPages) {
        Object.entries(value.innerPages).forEach(([innerKey, innerValue]) => {
          innerPages.push({
            formId: innerKey,
            formName: innerValue.name,
            parentFormId: key,
            displayOrder: innerValue.displayOrder,
          });
        });
      }
    });
  
    return { mainPages, innerPages };
  };
  
  const flatPages = getFlatPages(pageData.pages);
  const { mainPages, innerPages } = flatPages;

  const handleCheckboxChange = (pageId, isMainPage) => {
    setSelectedPages((prev) => {
      if (isMainPage) {
        const isAlreadySelected = prev.includes(pageId);
        const relatedInnerPages = mainPages.find((page) => page.formId === pageId)?.subForms || [];
  
        if (isAlreadySelected) {
          return prev.filter((id) => id !== pageId && !relatedInnerPages.includes(id));
        } else {
          return [...prev, pageId, ...relatedInnerPages];
        }
      } else {
        const parentPageId = innerPages.find((page) => page.formId === pageId)?.parentFormId;
        if (parentPageId && !prev.includes(parentPageId)) {
          return prev;
        }
  
        return prev.includes(pageId) ? prev.filter((id) => id !== pageId) : [...prev, pageId];
      }
    });
  };

  const handleAdd = async () => {
    const trimmedRoleName = roleName.trim();
    const trimmedDescription = description.trim();

    if (!trimmedRoleName || !trimmedDescription || selectedPages.length === 0) {
      alert("Role Name, Description, and at least one selected page are required.");
      return;
    }

    const createPayload = {
      description: trimmedDescription,
      roleName: trimmedRoleName,
    };

    try {
      const createResponse = await apiService.post("/user-roles/create", createPayload);
      if (createResponse.data && createResponse.data.userRoleId) {
        setUserRoleId(createResponse.data.userRoleId);

        const newPayload = {
          userRoleId: userRoleId,
          forms: mainPages
            .map((mainPage) => {
              if (selectedPages.includes(Number(mainPage.formId))) {
                return {
                  formId: mainPage.formId,
                  formName: mainPage.formName,
                  displayOrder: mainPage.displayOrder,
                  subForms: innerPages
                    .filter(
                      (innerPage) =>
                        innerPage.parentFormId === mainPage.formId &&
                        selectedPages.includes(Number(innerPage.formId))
                    )
                    .map((innerPage) => ({
                      formId: innerPage.formId,
                      formName: innerPage.formName,
                      displayOrder: innerPage.displayOrder,
                    })),
                };
              }
              return null;
            })
            .filter((form) => form !== null),
        };

        try {
          const grantAccessResponse = await apiService.post("/rbac/grant-access", newPayload);
          if (grantAccessResponse.data.status === true) {
            alert("Access Added Successfully");
            navigate(-1);
          }
        } catch (error) {
          console.error("Error granting access:", error);
          alert("Failed to grant access.");
        }
      } else {
        alert("Failed to create user role.");
      }
    } catch (error) {
      console.error("Error creating user role:", error);
      alert("Failed to create user role.");
    }
  };

  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowX: "auto" }}>
      <div className="d-flex justify-content-between align-items-center mx-3">
      <Header title="Add User Role & Access"/>
      <Button
          variant="contained"
          color="primary"
          sx={{
            padding: "10px 10px",
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "none",
            borderRadius: "12px",
            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
            '&:hover': {
              background: "linear-gradient(90deg, #1565c0, #2196f3)",
            },
          }}
          onClick={handleAdd}
        >
          Save
        </Button>
      </div>
      <Card className="mx-5 mb-2">
      <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{fontWeight:"bold"}}>Enter Details</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
      <Row>
        {/* Role Name Section */}
        <Col md={6}>
          <Form.Group controlId="roleName">
            <Form.Label style={{fontWeight:"bold"}}>Role Name</Form.Label>
            <Form.Control type="text" placeholder="Enter role name" onChange={(e)=>{setRoleName(e.target.value)}} />
          </Form.Group>
        </Col>
        
        {/* Description Section */}
        <Col md={6}>
          <Form.Group controlId="description">
            <Form.Label style={{fontWeight:"bold"}}>Description</Form.Label>
            <Form.Control as="textarea" placeholder="Enter description" rows={3} onChange={(e)=>{setDescription(e.target.value)}} />
          </Form.Group>
        </Col>
      </Row>
    </Form>
      </Card>
        <Card className="mx-5">
          <CardHeader>
            <div className="d-flex justify-content-between">
              <h6 style={{fontWeight:"bold"}}>Select Pages For Access</h6>
            </div>
          </CardHeader>
          <Form className="p-4">
            {mainPages.map((page) => (
              <div key={page.formId}>
                <Form.Check
                  type="checkbox"
                  label={page.formName}
                  onChange={() => handleCheckboxChange(Number(page.formId), true)}
                  className="mb-2 main-page"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                />
                {innerPages
                  .filter((innerPage) => innerPage.parentFormId === page.formId)
                  .map((innerPage) => (
                    <Form.Check
                      key={innerPage.formId}
                      type="checkbox"
                      label={innerPage.formName}
                      onChange={() => handleCheckboxChange(Number(innerPage.formId), false)}
                      className="mb-2 inner-page"
                      style={{
                        fontWeight: "normal",
                        fontSize: "14px",
                        marginLeft: "20px",
                      }}
                      disabled={!selectedPages.includes(Number(page.formId))} 
                    />
                  ))}
              </div>
            ))}
          </Form>
        </Card>
      </div>
    </Box>
  )
}

export default AddUserRole